import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import { Button, LayerBottom } from 'components'
import styles from './index.module.css'
import DetailTip from 'views/mydata/common/DetailTip'
import stationImg from 'images/tmp_inspection_station.png'
import carDetail from 'images/tmp_car_detail_image.png'
import profileImg1 from 'images/influencer_profile01.svg'
import profileImg2 from 'images/influencer_profile02.svg'
import carImg1 from 'images/tmp_fincar_image01.png'
import carImg2 from 'images/tmp_fincar_image02.png'

const FincarDetail = () => {

	const App = useApp()

	const [menuOpen, setMenuOpen] = useState()
	const [detailTip, setDetailTip] = useState(false)

	const openDetail = () => {
		setDetailTip(true)
	}

	const closeDetail = () => {
		setDetailTip(false)
	}

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" />,
			right: <div className={styles["compare-box"]}>
				<i className="icon_compare_line" />
				<div>비교함 <span>1</span></div>
			</div>,
		})

		App.setShowNav(false)
		App.setMainClass("white")

	}, [])

	return (
		<div className="page pb_100">

			{/* 차량정보 */}
			<div className="shadow">

				{/* 판매중 일 때 */}
				<div className={`${styles["car-detail-img"]} ${styles["car-list"]}`}>

					{/* 슬라이드 이미지 */}
					<div className="slider">
						<ul>
							<li>
								<div className="img-box">
									<img src={carDetail} alt="" />

									{/* 차량 상세페이지에서는 on/off 불가 */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like} ${styles.on}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare} ${styles.on}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>

									<div className={styles["tag-group"]}>
										<i className="tag tag-red">NEW</i>
										<i className="tag tag-blue">30대 남성 선호</i>
									</div>
								</div>
							</li>
						</ul>
						<div className={styles["slider-paging"]}>
							<span>1</span>
							<span style={{ margin: "0 0.3rem" }}>/</span>
							<span>5</span>
						</div>
					</div>

					<div className={styles.watcher}>
						<strong className="text-blue">4명</strong>이 이 차를 보고 있어요!
					</div>

					<div className="padding py_30">
						<div className="flex-justify_between align_center">
							<span className="license-plate">245 무 1245</span>
							<i className="icon icon_share" />
						</div>
						<div className={`${styles["car-guide"]} mt_20`}>
							<div className={styles.tit}>2021 현대 그랜저 3.3 가솔린</div>
							<div className={`${styles["opt"]} mt_5`}>
								<span>15년식</span>
								<span>67,960km</span>
								<span>가솔린</span>
							</div>
							<div className={`${styles.price} mt_15`}>
								<strong>13,800</strong>만원
							</div>
						</div>
					</div>
				</div>

				{/* 판매완료 일 때 */}
				<div className={`${styles["car-detail-img"]} ${styles["car-list"]}`}>

					{/* 슬라이드 이미지 */}
					<div className="slider">
						<ul>
							<li className={styles["sold-out"]}>
								<div className="img-box">
									<img src={carDetail} alt="" />

									{/* 차량 상세페이지에서는 on/off 불가 */}
									<div className={styles["click-option"]}>
										<span className={`${styles.like} ${styles.on}`}>
											<i className="icon icon_heart_line" />
										</span>
										<span className={`${styles.compare} ${styles.on}`}>
											<i className="icon icon_compare_line" />
										</span>
									</div>

									<div className={styles["tag-group"]}>
										<i className="tag tag-red">NEW</i>
										<i className="tag tag-blue">30대 남성 선호</i>
									</div>

									<div className={styles["sold-out-txt"]}><span>판매완료</span></div>
								</div>
							</li>
						</ul>
						<div className={styles["slider-paging"]}>
							<span>1</span>
							<span style={{ margin: "0 0.3rem" }}>/</span>
							<span>5</span>
						</div>
					</div>

					<div className={styles.watcher}>
						이미 <strong className="text-red">판매완료</strong> 된 차량이에요.
					</div>

					<div className="padding py_30">
						<div className="flex-justify_between align_center">
							<span className="license-plate">245 무 1245</span>
							<i className="icon icon_share" />
						</div>
						<div className={`${styles["car-guide"]} mt_20`}>
							<div className={styles.tit}>2021 현대 그랜저 3.3 가솔린</div>
							<div className={`${styles["opt"]} mt_5`}>
								<span>15년식</span>
								<span>67,960km</span>
								<span>가솔린</span>
							</div>
							<div className={`${styles.price} ${styles.out} mt_15`}>
								<strong>13,800</strong>만원
							</div>
						</div>
					</div>
				</div>

				<ul className={`${styles["car-detail-box"]} padding pt_0`}>
					<li>
						<span>성능점검</span>
						<span className="text-blue">등록</span>
					</li>
					<li>
						<span>보험이력</span>
						<span><span className="text-blue">1</span>건</span>
					</li>
					<li>
						{/* 주행거리 color -> 매우 적음/적음 (#333), 보통 (#00cbbc), 매우 많음/많음 (#fe6a6a) */}
						<span>주행거리</span>
						<span style={{ color: "#fe6a6a" }}>매우 많음</span>
					</li>
					<li>
						<span>신차대비</span>
						<span className="text-blue">59%</span>
					</li>
				</ul>
			</div>

			{/* 기본정보 */}
			<div className="shadow">
				<div className="padding py_30">
					<h3>기본정보</h3>
					<ul className="list-item mt_30" style={{ fontSize: "1.4rem" }}>
						<li>
							<span>배기량</span>
							<span>1,955 cc</span>
						</li>
						<li>
							<span>변속기</span>
							<span>오토</span>
						</li>
						<li>
							<span>차종</span>
							<span>SUV</span>
						</li>
						<li>
							<span>색상</span>
							<span>복합 9.3km/l</span>
						</li>
						<li>
							<span>제시번호</span>
							<span>2022022</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 차량옵션 */}
			<div className="shadow">
				<div className="padding py_30">
					<div className="flex-justify_between align_center">
						<h3>차량옵션</h3>
						<i className="icon icon_arrow_sm icon_arrow_md right" />
					</div>
					<ul className="car-option mt_30">
						<li>
							<i className="icon icon_car_option icon_car_option_navi active" />
							<span>내비게이션</span>
						</li>
						<li>
							<i className="icon icon_car_option icon_car_option_key active" />
							<span>스마트키</span>
						</li>
						<li>
							<i className="icon icon_car_option icon_car_option_camera active" />
							<span>후방카메라</span>
						</li>
						<li>
							<i className="icon icon_car_option icon_car_option_heat" />
							<span>열선시트</span>
						</li>
					</ul>
				</div>
			</div>

			{/* 차량 구매 일지 */}
			<div className="shadow">
				<div className="padding py_30">
					<h3>핀카의 차량 구매 일지</h3>
					<div className={`${styles["car-guide"]} mt_20`}>
						<div className={styles.tit}>볼보 XC40 2.0 B4 AWD 인스크립션</div>
						<div className={`${styles["opt"]} mt_10`} style={{ fontSize: "1.4rem" }}>
							<span>2019.03.02</span>
						</div>
						<div className={`${styles["cont-wrap"]} mt_20`}>
							<div className={`${styles.cont}`}>
								대한민국 No.1 중고차 필수 플랫폼 Encar
								중고차 앱 누적 다운로드 수 1위, 일 75만명 방문하는 국내 최대 규모 중고차 거래 플랫폼 엔카
								1분에 1대씩 거래되는 믿을 수 있는 엔카로 쉽게 경
								대한민국 No.1 중고차 필수 플랫폼 Encar
								중고차 앱 누적 다운로드 수 1위, 일 75만명 방문하는 국내 최대 규모 중고차 거래 플랫폼 엔카
								1분에 1대씩 거래되는 믿을 수 있는 엔카로 쉽게 경
								대한민국 No.1 중고차 필수 플랫폼 Encar
								중고차 앱 누적 다운로드 수 1위, 일 75만명 방문하는 국내 최대 규모 중고차 거래 플랫폼 엔카
								1분에 1대씩 거래되는 믿을 수 있는 엔카로 쉽게 경
								대한민국 No.1 중고차 필수 플랫폼 Encar
								중고차 앱 누적 다운로드 수 1위, 일 75만명 방문하는 국내 최대 규모 중고차 거래 플랫폼 엔카
								1분에 1대씩 거래되는 믿을 수 있는 엔카로 쉽게 경
							</div>
						</div>
					</div>

					<Button className="btn btn--big btn-more mt_20">영수증보기</Button>
				</div>
			</div>

			{/* 자동차 구매 시기 예측 */}
			<div className="shadow">
				<div className="padding py_30">
					<div className="flex-justify_between align_center">
						<h3>자동차 구매 시기 예측</h3>

						{/* 마이데이터 연결전에는 arrow 삭제 */}
						<i className="icon icon_arrow_sm icon_arrow_md right" />
					</div>

					{/* 구매가능인 경우 */}
					<div className={`${styles.purchase} ${styles.yes} mt_40`}>
						<span>구매 가능 시기</span>
						<strong>4년 이후 ~</strong>
					</div>
					<div className={`${styles["ui-slider"]} mt_30`}>
						<div className={styles} style={{ left: "29%", width: "40%" }} />
						<span style={{ left: "29%" }} />
						<span style={{ left: "68%" }} />
					</div>
					<div className="flex-justify_between align_center mt_15" style={{ color: "#666", fontWeight: 500, fontSize: "1.2rem" }}>
						<span>현재&nbsp;</span>
						<span>2년후</span>
						<span>4년후</span>
						<span>6년후</span>
						<span>8년후</span>
						<span>10년후</span>
						<span>12년후</span>
						<span>14년후</span>
					</div>

					{/* 구매불가인 경우 */}
					<div className={`${styles.purchase} ${styles.no} mt_40`}>
						<span>구매 가능 시기</span>
						<strong>예산부족</strong>
					</div>
					<div className={`${styles["ui-slider"]} mt_30`}></div>
					<div className="flex-justify_between align_center mt_15" style={{ color: "#666", fontWeight: 500, fontSize: "1.2rem" }}>
						<span>현재&nbsp;</span>
						<span>2년후</span>
						<span>4년후</span>
						<span>6년후</span>
						<span>8년후</span>
						<span>10년후</span>
						<span>12년후</span>
						<span>14년후</span>
					</div>

					{/* 마이데이터 연결되어있지 않은 경우 */}
					<div className={`${styles.purchase} ${styles.connect} mt_40`}>
						<div>아직 마이데이터를 연결하지 않으셨나요?</div>
						<span className="mt_10">마이데이터를 연결하고,<br />자동차 구매 가능 시기를 확인해보세요.</span>
						<div className={`${styles["btn-text"]} mt_20`}>+ 데이터 연결하기</div>
					</div>

					<div className="btn-group mt_40">
						<Button className="btn btn--md flex_1" style={{ height: "4rem" }}>상품추천</Button>
						<Button className="btn btn--md btn--dark flex_1 ml_10" style={{ height: "4rem" }}>구매 시뮬레이션</Button>
					</div>
				</div>
			</div>

			{/* 차량 히스토리 */}
			<div className="shadow">
				<div className="padding py_30">
					<div className="flex-justify_between align_center">
						<h3>차량 히스토리</h3>
						<i className="icon icon_arrow_sm icon_arrow_md right" />
					</div>

					{/* 데이터 있을 때 */}
					<div className="flex-justify_center mt_30">
						<strong>2022.05.20</strong>
					</div>
					<div className={`${styles.chat} mt_30`}>
						<div>
							<div className={`${styles.female} img-box`}>
								<img src={profileImg1} alt="" />
							</div>
							<div className={styles.txt}>
								<span>20대 여자</span>
								<div>
									<div className={styles.bubble}>
										<span>관심 등록을 완료 하였습니다. 관심 등록을 완료 하였습니다. 관심 등록을 완료 하였습니다.</span>
									</div>
									<span className={styles.time}>18:21</span>
								</div>
							</div>
						</div>
						<div>
							<div className={`${styles.male} img-box`}>
								<img src={profileImg2} alt="" />
							</div>
							<div className={styles.txt}>
								<span>20대 남자</span>
								<div>
									<div className={styles.bubble}>
										<span>관심 등록을 완료 하였습니다.</span>
									</div>
									<span className={styles.time}>18:21</span>
								</div>
							</div>
						</div>
						<div>
							<div className={`${styles.female} img-box`}>
								<img src={profileImg1} alt="" />
							</div>
							<div className={styles.txt}>
								<span>20대 여자</span>
								<div>
									<div className={styles.bubble}>
										<span>관심 등록을 완료 하였습니다.</span>
									</div>
									<span className={styles.time}>09:22</span>
								</div>
							</div>
						</div>
					</div>

					{/* 데이터 없을 때 */}
					<div className="center-cont no-data-box py_40 mt_30">
						<p style={{ fontSize: "1.6rem" }}>
							관심등록 또는 예약을 통해<br />차량의 히스토리를 쌓아보세요!
						</p>
						<i className="icon icon_calendar_object mt_30" />
					</div>
				</div>
			</div>

			{/* 선호비율 */}
			<div className="shadow">
				<div className="padding py_30">
					<h3>선호비율</h3>
					<ul className="accordion-list mt_20">
						<li className={`${menuOpen === 0 ? "active" : ""} py_10`} onClick={() => setMenuOpen(0)}>
							<div className="flex-justify_between align_center" style={{ fontSize: "1.6rem" }}>
								<div className="flex-align_center">
									<strong className="text-blue mr_10">제네시스</strong> 를 보는 사람들
								</div>
								<i className="icon icon_arrow_sm bottom" />
							</div>
							<div className="menu-open mt_20">
								<div className={styles["box-gray"]}>
									<div>
										조회수 <strong className="text-blue" style={{ verticalAlign: "inherit" }}>23,552</strong> 회
									</div>

									{/* 성별 */}
									<p className="mt_20">성별</p>
									<div className={`${styles["bar-inline"]} mt_20`}>

										{/* 20% 미만일때는 span text 삭제 */}
										<div className={`${styles.bar} ${styles.female}`} style={{ width: "40%", left: 0 }}>
											<span>40%</span>
										</div>
										<div className={`${styles.bar} ${styles.male}`} style={{ width: "60%", left: "40%" }}>
											<span>60%</span>
										</div>
									</div>
									<ul className="list-item mt_30" style={{ fontSize: "1.4rem" }}>
										<li className="color-title">
											<p className="red">여성</p>
											<span>40%</span>
										</li>
										<li className="color-title">
											<p className="light-blue">남성</p>
											<span>60%</span>
										</li>
									</ul>

									<hr className="mt_20" />

									{/* 연령대 */}
									<p className="mt_20">연령대</p>
									<ul className={`${styles["age-area"]} mt_20`}>
										<li>
											<span>20대</span>
											<div className={`${styles["bar-block"]} ${styles.focus}`}>
												<div style={{ width: "70%" }}>
													<span>70%</span>
												</div>
											</div>
										</li>

										{/* 20% 미만인 경우 span에 스타일 추가 */}
										<li>
											<span>20대</span>
											<div className={styles["bar-block"]}>
												<div style={{ width: "12%" }}>
													<span style={{ position: "absolute", left: "100%", marginLeft: "0.5rem" }}>12%</span>
												</div>
											</div>
										</li>
										<li>
											<span>40대</span>
											<div className={styles["bar-block"]}>
												<div style={{ width: "11%" }}>
													<span style={{ position: "absolute", left: "100%", marginLeft: "0.5rem" }}>11%</span>
												</div>
											</div>
										</li>
										<li>
											<span>50대</span>
											<div className={styles["bar-block"]}>
												<div style={{ width: "7%" }}>
													<span style={{ position: "absolute", left: "100%", marginLeft: "0.5rem" }}>7%</span>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</li>
						<li className={`${menuOpen === 1 ? "active" : ""} py_10 mt_0`} onClick={() => setMenuOpen(1)}>
							<div className="flex-justify_between align_center" style={{ fontSize: "1.6rem" }}>
								<div className="flex-align_center">
									<strong className="text-blue mr_10">제네시스</strong> 를 찜한 사람들
								</div>
								<i className="icon icon_arrow_sm bottom" />
							</div>
							<div className="menu-open mt_20">
								<div className={styles["box-gray"]}>
									<div>
										총 찜하기 수 <strong className="text-blue" style={{ verticalAlign: "inherit" }}>23,552</strong> 회
									</div>

									{/* 성별 */}
									<p className="mt_20">성별</p>
									<div className={`${styles["bar-inline"]} mt_20`}>

										{/* 20% 미만일때는 span text 삭제 */}
										<div className={`${styles.bar} ${styles.female}`} style={{ width: "40%", left: 0 }}>
											<span>40%</span>
										</div>
										<div className={`${styles.bar} ${styles.male}`} style={{ width: "60%", left: "40%" }}>
											<span>60%</span>
										</div>
									</div>
									<ul className="list-item mt_30" style={{ fontSize: "1.4rem" }}>
										<li className="color-title">
											<p className="red">여성</p>
											<span>40%</span>
										</li>
										<li className="color-title">
											<p className="light-blue">남성</p>
											<span>60%</span>
										</li>
									</ul>

									<hr className="mt_20" />

									{/* 연령대 */}
									<p className="mt_20">연령대</p>
									<ul className={`${styles["age-area"]} mt_20`}>
										<li>
											<span>20대</span>
											<div className={`${styles["bar-block"]} ${styles.focus}`}>
												<div style={{ width: "70%" }}>
													<span>70%</span>
												</div>
											</div>
										</li>

										{/* 20% 미만인 경우 span에 스타일 추가 */}
										<li>
											<span>20대</span>
											<div className={styles["bar-block"]}>
												<div style={{ width: "12%" }}>
													<span style={{ position: "absolute", left: "100%", marginLeft: "0.5rem" }}>12%</span>
												</div>
											</div>
										</li>
										<li>
											<span>40대</span>
											<div className={styles["bar-block"]}>
												<div style={{ width: "11%" }}>
													<span style={{ position: "absolute", left: "100%", marginLeft: "0.5rem" }}>11%</span>
												</div>
											</div>
										</li>
										<li>
											<span>50대</span>
											<div className={styles["bar-block"]}>
												<div style={{ width: "7%" }}>
													<span style={{ position: "absolute", left: "100%", marginLeft: "0.5rem" }}>7%</span>
												</div>
											</div>
										</li>
									</ul>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</div>

			{/* 보증정보 */}
			<div className="shadow">
				<div className="padding py_30">
					<div className="flex-align_center">
						<h3>보증정보</h3>
						<i className="icon icon_question ml_5" onClick={openDetail} />
					</div>
					<ul className={`${styles.warranty} mt_30`}>
						<li>
							<div className={styles.tit}>
								<p>차체 및 일반부품</p>
								<span>보증기간 종료</span>
							</div>
							<div className={styles.bar}>
								<span style={{ width: 0 }} />
							</div>
						</li>
						<li>
							<div className={styles.tit}>
								<p>엔진 및 동력전달 주요 부품</p>
								<span>10년/21,652km</span>
							</div>
							<div className={styles.bar}>
								<span style={{ width: "30%" }} />
							</div>
						</li>
					</ul>
				</div>
			</div>

			{/* 전시장 */}
			<div className="shadow">
				<div className="padding py_30">
					<h3>전시장</h3>
					<ul className="list-item mt_30" style={{ fontSize: "1.4rem" }}>
						<li>
							<span className="flex-align_center">
								<i className="icon_life icon_life_place icon mr_5" />
								주소
							</span>
							<span>서울 양천구 신정동 162-56(08104)</span>
						</li>
						<li>
							<span className="flex-align_center">
								<i className="icon_life icon_life_time icon mr_5" />
								영업시간
							</span>
							<span>월-토 9:00 ~ 18:00 (공휴일, 일요일 휴일)</span>
						</li>
						<li>
							<span className="flex-align_center">
								<i className="icon_life icon_life_food icon mr_5" />
								점심시간
							</span>
							<span>12:00 ~ 13:00</span>
						</li>
					</ul>
					<div className="img-box mt_20" style={{ height: "20rem" }}>
						<img src={stationImg} alt="" />
					</div>
				</div>
			</div>


			<div className="padding py_30">
				<div className="flex-justify_between align_center">
					<h3>추천차량</h3>
					<i className="icon icon_arrow_sm icon_arrow_md right" />
				</div>
			</div>
			<div className="no-scroll pb_30" style={{ overflowX: "auto" }}>
				<ul className={`${styles["car-list"]} ${styles["type-inline"]}`}>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg1} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like} ${styles.on}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles["tag-group"]}>
									<i className="tag tag-red">NEW</i>
									<i className="tag tag-blue">30대 남성 선호</i>
								</div>
								<div className={styles.title}>기아 EV6 롱 레인지 4WD 어스</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
					<li>
						<div className={styles.info}>
							<div className={`${styles["car-img"]} img-box`}>
								<img src={carImg2} alt="" />

								{/* on/off */}
								<div className={styles["click-option"]}>
									<span className={`${styles.like} ${styles.on}`}>
										<i className="icon icon_heart_line" />
									</span>
									<span className={`${styles.compare} ${styles.on}`}>
										<i className="icon icon_compare_line" />
									</span>
								</div>
							</div>
							<div className={`${styles.txt} mt_20`}>
								<div className={styles.title}>기아 더 K9 3.8 GDI 4WD 플래티넘 Ⅰ</div>
								<span>21년식 67,000km</span>
								<div className={styles.price}>
									<strong>6,500</strong> 만원
								</div>
							</div>
						</div>
					</li>
				</ul>
			</div>

			{/* 판매중일 때 버튼 */}
			<div className="padding btn--fixed btn-group">
				<Button className="btn btn--big flex_1">문의하기</Button>
				<Button className="btn btn--big btn--dark flex_1 ml_10">채팅상담</Button>
				<Button className="btn btn--big btn--gray flex_1 ml_10">예약하기</Button>
			</div>

			{/* 판매완료일 때 버튼 */}
			{/* <div className="padding btn--fixed">
				<Button className="btn btn--big btn--gray">판매 완료된 차량이에요.</Button>
			</div> */}

			<DetailTip show={detailTip} closeLayer={closeDetail} title="보증정보" content={
				<>
					제조사에서 제공하는 정보 기준, 차량의 보증 잔여 현황을 알려드립니다. 본 정보는 참고용으로만 활용하시고, 보다 정확한 보증 정보는 제조사에 직접 확인해주시기 바랍니다.
				</>
			} />

		</div >
	)
}

export default FincarDetail